"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setHours = exports.getTime = exports.checkTimeFormat = exports.TIME_LABEL = exports.ROW_HEIGHT = exports.MERIDIEM_TYPE = exports.LIST_HEIGHT = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _utils = require("@trs/utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var TIME_RGX = /^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$/;
var NR_ROWS = 8;
var MINUTES = ['00', '15', '30', '45', '59'];
var TIME_LABEL = exports.TIME_LABEL = 'Time';
var MERIDIEM_TYPE = exports.MERIDIEM_TYPE = ['AM', 'PM'];
var ROW_HEIGHT = exports.ROW_HEIGHT = 30;
var LIST_HEIGHT = exports.LIST_HEIGHT = NR_ROWS * ROW_HEIGHT;
var setTimeDigits = function setTimeDigits(value) {
  var isMeridiem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return !isMeridiem && (0, _utils.formatTimeDigit)(value);
};
var setMeridiemHour = function setMeridiemHour(value) {
  var hour = value % 12;
  return hour === 0 ? 12 : hour;
};
var getMeridiem = function getMeridiem(date) {
  return date.toLocaleTimeString().slice(-2);
};
var fillRange = function fillRange(_ref) {
  var start = _ref.start,
    end = _ref.end;
  return R.range(start, end);
};
var constructHour = function constructHour(hour, isMeridiem) {
  return R.map(function (minute) {
    return "".concat(setTimeDigits(hour, isMeridiem), ":").concat(minute);
  }, MINUTES);
};
var setHours = exports.setHours = function setHours() {
  var isMeridiem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var range = {
    start: isMeridiem ? 1 : 0,
    end: isMeridiem ? 13 : 24
  };
  var arr = R.map(function (hour) {
    return constructHour(hour, isMeridiem);
  }, fillRange(range));
  return arr.concat.apply([], arr);
};
var getTime = exports.getTime = function getTime(date, isMeridiem) {
  if ((0, _utils.isBlank)(date)) return null;
  var h = isMeridiem ? setMeridiemHour(date.getHours()) : setTimeDigits(date.getHours());
  var m = setTimeDigits(date.getMinutes());
  return "".concat(h, ":").concat(m, " ").concat(isMeridiem ? getMeridiem(date) : '').trim();
};
var checkTimeFormat = exports.checkTimeFormat = function checkTimeFormat(_ref2) {
  var value = _ref2.value,
    hours = _ref2.hours,
    isMeridiem = _ref2.isMeridiem;
  if (TIME_RGX.test(value.split(' ')[0])) {
    return value;
  }
  return value ? "".concat(R.head(hours), " ").concat(isMeridiem ? MERIDIEM_TYPE[0] : '').trim() : '';
};